import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Users, Award, Target, Clock, Smartphone, ArrowRight, MapPin, Check } from 'lucide-react';
import { Link } from 'react-router-dom';

const AboutPage: React.FC = () => {
  return (
    <div className="pt-24">
      <Helmet>
        <title>Über uns - Easy Vertrag Völklingen | Ihr Mobilfunk Partner im Saarland</title>
        <meta name="description" content="Easy Vertrag in Völklingen (Saarland) - Ihr lokaler Experte für Handyverträge, Smartphones, Internet und Energie. Persönliche Beratung für Kunden aus Völklingen, Saarbrücken und dem Saarland." />
        <meta name="keywords" content="Easy Vertrag Völklingen, Mobilfunk Beratung Saarland, Handyvertrag Völklingen, Smartphone Beratung Saarbrücken, lokaler Mobilfunkpartner" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://easy4vertrag.de/uber-uns" />
        <meta property="og:title" content="Über uns - Easy Vertrag" />
        <meta property="og:description" content="Ihr vertrauenswürdiger Partner für Smartphones, Tablets und Handytarife. Qualität, faire Preise und exzellenter Kundenservice." />
        <meta property="og:url" content="https://easy4vertrag.de/uber-uns" />
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {"@type": "ListItem", "position": 1, "name": "Startseite", "item": "https://easy4vertrag.de/"},
              {"@type": "ListItem", "position": 2, "name": "Über uns", "item": "https://easy4vertrag.de/uber-uns"}
            ]
          }
        `}</script>
      </Helmet>
      {/* Hero Section */}
      <section className="bg-green-600 text-white py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl font-bold mb-4">Easy Vertrag in Völklingen - Ihr Mobilfunk-Partner im Saarland</h1>
            <p className="text-xl text-blue-100">
              Ihr persönlicher Ansprechpartner für Handyverträge, Smartphones, Internet und Energie in Völklingen und dem gesamten Saarland.
            </p>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto">
            <div className="flex justify-center mb-8">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center">
                <Target className="w-8 h-8 text-blue-600" />
              </div>
            </div>
            <h2 className="text-3xl font-bold text-center text-gray-800 mb-6">Unsere Mission - Handyverträge in Völklingen einfach gemacht</h2>
            <p className="text-lg text-gray-600 text-center mb-4">
              Bei EASY VERTRAG in Völklingen glauben wir daran, dass jeder im Saarland Zugang zu hochwertiger Technologie zu fairen Preisen haben sollte. Als lokaler Partner beraten wir Sie persönlich und finden den besten Handyvertrag, Internettarif oder Energievertrag für Sie.
            </p>
            <p className="text-gray-600 text-center mb-8">
              Wir sind in der Bismarck Straße 31 in Völklingen ansässig und betreuen Kunden aus der gesamten Saar-Region: Völklingen, Saarbrücken, Saarlouis, Dillingen, Wadgassen und Umgebung.
            </p>
            <div className="grid md:grid-cols-3 gap-8 mt-12">
              <div className="text-center">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Award className="w-6 h-6 text-blue-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-2">Qualität</h3>
                <p className="text-gray-600">
                  Wir arbeiten nur mit renommierten Herstellern und Anbietern zusammen, um Ihnen beste Qualität zu garantieren.
                </p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Users className="w-6 h-6 text-blue-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-2">Kundenzufriedenheit</h3>
                <p className="text-gray-600">
                  Ihr Vertrauen ist unser größter Erfolg. Wir stehen Ihnen bei allen Fragen und Anliegen zur Seite.
                </p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Clock className="w-6 h-6 text-blue-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-2">Innovation</h3>
                <p className="text-gray-600">
                  Wir halten Schritt mit den neuesten Entwicklungen, um Ihnen immer die modernsten Produkte anbieten zu können.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/*{/* Team Section 
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">Unser Team</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Lernen Sie die Experten kennen, die TechStore zu dem machen, was es ist: ein Ort für kompetente Beratung und exzellenten Service.
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <div className="h-64 overflow-hidden">
                <img 
                  src="https://images.pexels.com/photos/2379005/pexels-photo-2379005.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" 
                  alt="Team Mitglied" 
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-800 mb-1">Markus Weber</h3>
                <p className="text-blue-600 font-medium mb-3">Geschäftsführer</p>
                <p className="text-gray-600 mb-4">
                  Mit über 15 Jahren Erfahrung in der Technologiebranche leitet Markus unser Unternehmen mit Leidenschaft und Vision.
                </p>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <div className="h-64 overflow-hidden">
                <img 
                  src="https://images.pexels.com/photos/3756679/pexels-photo-3756679.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" 
                  alt="Team Mitglied" 
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-800 mb-1">Laura Schmitz</h3>
                <p className="text-blue-600 font-medium mb-3">Produktmanagerin</p>
                <p className="text-gray-600 mb-4">
                  Laura hat ein unvergleichliches Gespür für Trends und sorgt dafür, dass wir immer die neuesten und besten Produkte im Angebot haben.
                </p>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <div className="h-64 overflow-hidden">
                <img 
                  src="https://images.pexels.com/photos/3785424/pexels-photo-3785424.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" 
                  alt="Team Mitglied" 
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-800 mb-1">Michael Bauer</h3>
                <p className="text-blue-600 font-medium mb-3">Kundenserviceleiter</p>
                <p className="text-gray-600 mb-4">
                  Michael und sein Team stehen Ihnen bei allen Fragen zur Seite und sorgen für eine reibungslose Kauferfahrung.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
*/}
      {/* Why Choose Us Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">Warum EASY VERTRAG?</h2>
            <p className="text-gray-600">
              Was uns von anderen unterscheidet und warum Sie uns vertrauen können
            </p>
          </div>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="flex items-start">
              <div className="flex-shrink-0 mr-4">
                <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                  <Smartphone className="w-5 h-5 text-blue-600" />
                </div>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-800 mb-2">Große Produktauswahl</h3>
                <p className="text-gray-600">
                  Wir bieten eine sorgfältig kuratierte Auswahl an Technikprodukten, die auf Qualität und Leistung geprüft wurden.
                </p>
              </div>
            </div>
            <div className="flex items-start">
              <div className="flex-shrink-0 mr-4">
                <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                  <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                  </svg>
                </div>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-800 mb-2">Beste Preise</h3>
                <p className="text-gray-600">
                  Durch unsere Partnerschaften mit führenden Anbietern können wir Ihnen exklusive Angebote und Rabatte anbieten.
                </p>
              </div>
            </div>
            <div className="flex items-start">
              <div className="flex-shrink-0 mr-4">
                <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                  <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path>
                  </svg>
                </div>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-800 mb-2">Vertrauenswürdige Beratung</h3>
                <p className="text-gray-600">
                  Unsere Experten bieten unabhängige und ehrliche Beratung, um Ihnen bei der Auswahl des richtigen Produkts zu helfen.
                </p>
              </div>
            </div>
            <div className="flex items-start">
              <div className="flex-shrink-0 mr-4">
                <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                  <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z"></path>
                  </svg>
                </div>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-800 mb-2">Ausgezeichneter Kundensupport</h3>
                <p className="text-gray-600">
                  Unser engagiertes Support-Team steht Ihnen vor, während und nach dem Kauf zur Verfügung, um all Ihre Fragen zu beantworten.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Service Area Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-800 mb-4 text-center">Unser Einzugsgebiet im Saarland</h2>
            <p className="text-gray-600 text-center mb-8 max-w-2xl mx-auto">
              Easy Vertrag berät Kunden persönlich in Völklingen sowie online und telefonisch aus dem gesamten Saarland. Besuchen Sie uns oder nutzen Sie unsere digitalen Beratungsangebote.
            </p>
            <div className="grid md:grid-cols-2 gap-8 items-start">
              <div className="bg-white p-6 rounded-xl shadow-sm">
                <div className="flex items-center gap-3 mb-4">
                  <MapPin className="w-6 h-6 text-blue-600 flex-shrink-0" />
                  <h3 className="font-bold text-gray-800 text-lg">Standort Völklingen</h3>
                </div>
                <p className="text-gray-600 mb-3">
                  <strong>Adresse:</strong><br />
                  Bismarck Straße 31<br />
                  66333 Völklingen, Saarland
                </p>
                <p className="text-gray-600 mb-3">
                  <strong>Öffnungszeiten:</strong><br />
                  Mo-Fr: 10:00 - 20:00 Uhr<br />
                  Sa: 10:00 - 18:00 Uhr
                </p>
                <Link to="/kontakt" className="inline-flex items-center text-blue-600 font-medium hover:underline text-sm">
                  Auf der Karte ansehen <ArrowRight className="ml-1 w-4 h-4" />
                </Link>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-sm">
                <h3 className="font-bold text-gray-800 text-lg mb-4">Wir betreuen Kunden aus:</h3>
                <ul className="grid grid-cols-2 gap-2">
                  {[
                    'Völklingen', 'Saarbrücken', 'Saarlouis', 'Dillingen/Saar',
                    'Wadgassen', 'Quierschied', 'Großrosseln', 'Heusweiler',
                    'Püttlingen', 'Friedrichsthal', 'Sulzbach', 'Riegelsberg',
                  ].map((city, i) => (
                    <li key={i} className="flex items-center gap-2 text-gray-600 text-sm">
                      <Check className="w-4 h-4 text-green-500 flex-shrink-0" />
                      {city}
                    </li>
                  ))}
                </ul>
                <p className="text-gray-500 text-xs mt-4">Beratung auch online & deutschlandweit möglich</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-green-600 text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl font-bold mb-6">Bereit, die besten Deals zu entdecken?</h2>
            <p className="text-xl text-blue-100 mb-8">
              Stöbern Sie durch unsere Produkte oder kontaktieren Sie uns für eine persönliche Beratung.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <Link
                to="/produkte/smartphones"
                className="px-6 py-3 bg-white text-blue-600 font-medium rounded-lg hover:bg-blue-50 transition-colors inline-flex items-center justify-center"
              >
                <span>Produkte entdecken</span>
                <ArrowRight className="ml-2 w-5 h-5" />
              </Link>
              <Link
                to="/kontakt"
                className="px-6 py-3 border-2 border-white bg-transparent text-white font-medium rounded-lg hover:bg-white hover:text-blue-600 transition-colors inline-flex items-center justify-center"
              >
                Kontakt aufnehmen
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;